require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _color = _interopRequireDefault(require("color"));

var _theming = require("../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/ProgressBar.tsx";
var INDETERMINATE_DURATION = 2000;
var INDETERMINATE_MAX_WIDTH = 0.6;
var isRTL = _reactNative.I18nManager.isRTL;

var ProgressBar = function (_React$Component) {
  (0, _inherits2["default"])(ProgressBar, _React$Component);

  function ProgressBar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ProgressBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ProgressBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      width: 0,
      timer: new _reactNative.Animated.Value(0),
      fade: new _reactNative.Animated.Value(0)
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "indeterminateAnimation", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onLayout", function (event) {
      var visible = _this.props.visible;
      var previousWidth = _this.state.width;

      _this.setState({
        width: event.nativeEvent.layout.width
      }, function () {
        if (visible && previousWidth === 0) {
          _this.startAnimation();
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "startAnimation", function () {
      var _this$props = _this.props,
          indeterminate = _this$props.indeterminate,
          progress = _this$props.progress,
          scale = _this$props.theme.animation.scale;
      var _this$state = _this.state,
          fade = _this$state.fade,
          timer = _this$state.timer;

      _reactNative.Animated.timing(fade, {
        duration: 200 * scale,
        toValue: 1,
        useNativeDriver: true,
        isInteraction: false
      }).start();

      if (indeterminate) {
        if (!_this.indeterminateAnimation) {
          _this.indeterminateAnimation = _reactNative.Animated.timing(timer, {
            duration: INDETERMINATE_DURATION,
            toValue: 1,
            useNativeDriver: _reactNative.Platform.OS !== 'web',
            isInteraction: false
          });
        }

        timer.setValue(0);

        _reactNative.Animated.loop(_this.indeterminateAnimation).start();
      } else {
        _reactNative.Animated.timing(timer, {
          duration: 200 * scale,
          toValue: progress ? progress : 0,
          useNativeDriver: true,
          isInteraction: false
        }).start();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stopAnimation", function () {
      var fade = _this.state.fade;
      var scale = _this.props.theme.animation.scale;

      if (_this.indeterminateAnimation) {
        _this.indeterminateAnimation.stop();
      }

      _reactNative.Animated.timing(fade, {
        duration: 200 * scale,
        toValue: 0,
        useNativeDriver: true,
        isInteraction: false
      }).start();
    });
    return _this;
  }

  (0, _createClass2["default"])(ProgressBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          progress = _this$props2.progress;

      if (progress !== prevProps.progress || visible !== prevProps.visible) {
        if (visible) {
          this.startAnimation();
        } else {
          this.stopAnimation();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          color = _this$props3.color,
          indeterminate = _this$props3.indeterminate,
          style = _this$props3.style,
          theme = _this$props3.theme,
          progress = _this$props3.progress,
          visible = _this$props3.visible,
          rest = (0, _objectWithoutProperties2["default"])(_this$props3, ["color", "indeterminate", "style", "theme", "progress", "visible"]);
      var _this$state2 = this.state,
          fade = _this$state2.fade,
          timer = _this$state2.timer,
          width = _this$state2.width;
      var tintColor = color || theme.colors.primary;
      var trackTintColor = (0, _color["default"])(tintColor).alpha(0.38).rgb().string();
      return React.createElement(_reactNative.View, (0, _extends2["default"])({
        onLayout: this.onLayout
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 188
        }
      }), React.createElement(_reactNative.Animated.View, {
        style: [styles.container, {
          backgroundColor: trackTintColor,
          opacity: fade
        }, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 189
        }
      }, React.createElement(_reactNative.Animated.View, {
        style: [styles.progressBar, {
          backgroundColor: tintColor,
          width: width,
          transform: [{
            translateX: timer.interpolate(indeterminate ? {
              inputRange: [0, 0.5, 1],
              outputRange: [(isRTL ? 1 : -1) * 0.5 * width, (isRTL ? 1 : -1) * 0.5 * INDETERMINATE_MAX_WIDTH * width, (isRTL ? -1 : 1) * 0.7 * width]
            } : {
              inputRange: [0, 1],
              outputRange: [(isRTL ? 1 : -1) * 0.5 * width, 0]
            })
          }, {
            scaleX: timer.interpolate(indeterminate ? {
              inputRange: [0, 0.5, 1],
              outputRange: [0.0001, INDETERMINATE_MAX_WIDTH, 0.0001]
            } : {
              inputRange: [0, 1],
              outputRange: [0.0001, 1]
            })
          }]
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 196
        }
      })));
    }
  }]);
  return ProgressBar;
}(React.Component);

(0, _defineProperty2["default"])(ProgressBar, "defaultProps", {
  visible: true,
  progress: 0
});

var styles = _reactNative.StyleSheet.create({
  container: {
    height: 4,
    overflow: 'hidden'
  },
  progressBar: {
    flex: 1
  }
});

var _default = (0, _theming.withTheme)(ProgressBar);

exports["default"] = _default;